import { ColliStateName } from '@frontend/colli/types';

/**
 * Maps PuDo parcels (collis) list tabs to API `state` filters.
 * Shared by the list fetch and export so cancelled/completed stay in sync.
 */
export const getPudoColliStatesForTab = (activeTab: string): ColliStateName[] | undefined => {
    switch (activeTab) {
        case 'all':
            return undefined;
        case 'completed':
            return [ColliStateName.COLLI_COMPLETED, ColliStateName.COLLI_COMPLETED_WITH_FAILURES];
        case 'cancelled':
            return [ColliStateName.COLLI_CANCELLED];
        case 'failed':
            return [ColliStateName.COLLI_FAILED, ColliStateName.COLLI_LOST];
        default:
            return [
                ColliStateName.COLLI_CREATED,
                ColliStateName.COLLI_PROCESSING,
                ColliStateName.COLLI_DROP_OFF_PENDING,
                ColliStateName.COLLI_PICK_UP_PENDING,
                ColliStateName.COLLI_IN_TRANSIT,
                ColliStateName.COLLI_BACK_TO_SENDER
            ];
    }
};
